declare namespace $ {

	type $shm_dashboard_admin_section_link__arg_shm_dashboard_admin_book_1 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_book['users_arg'] >
		,
		ReturnType< $shm_dashboard_admin_section_link['arg'] >
	>
	type $shm_dashboard_admin_section_link__title_shm_dashboard_admin_book_2 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_dashboard_admin_section_link['title'] >
	>
	type $shm_dashboard_admin_section_link__current_shm_dashboard_admin_book_3 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_book['users_current'] >
		,
		ReturnType< $shm_dashboard_admin_section_link['current'] >
	>
	type $shm_dashboard_admin_section_link__arg_shm_dashboard_admin_book_4 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_book['wordstat_arg'] >
		,
		ReturnType< $shm_dashboard_admin_section_link['arg'] >
	>
	type $shm_dashboard_admin_section_link__title_shm_dashboard_admin_book_5 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_dashboard_admin_section_link['title'] >
	>
	type $shm_dashboard_admin_section_link__current_shm_dashboard_admin_book_6 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_book['wordstat_current'] >
		,
		ReturnType< $shm_dashboard_admin_section_link['current'] >
	>
	type $shm_dashboard_admin_section_link__arg_shm_dashboard_admin_book_7 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_book['monitoring_arg'] >
		,
		ReturnType< $shm_dashboard_admin_section_link['arg'] >
	>
	type $shm_dashboard_admin_section_link__title_shm_dashboard_admin_book_8 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_dashboard_admin_section_link['title'] >
	>
	type $shm_dashboard_admin_section_link__current_shm_dashboard_admin_book_9 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_book['monitoring_current'] >
		,
		ReturnType< $shm_dashboard_admin_section_link['current'] >
	>
	type $shm_dashboard_admin_section_link__arg_shm_dashboard_admin_book_10 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_book['server_arg'] >
		,
		ReturnType< $shm_dashboard_admin_section_link['arg'] >
	>
	type $shm_dashboard_admin_section_link__title_shm_dashboard_admin_book_11 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_dashboard_admin_section_link['title'] >
	>
	type $shm_dashboard_admin_section_link__current_shm_dashboard_admin_book_12 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_book['server_current'] >
		,
		ReturnType< $shm_dashboard_admin_section_link['current'] >
	>
	type $mol_view__sub_shm_dashboard_admin_book_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_book_14 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_book['menu_session_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_footer__version_shm_dashboard_admin_book_15 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_book['version_data_version'] >
		,
		ReturnType< $shm_hitalama_footer['version'] >
	>
	type $shm_hitalama_footer__date_shm_dashboard_admin_book_16 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_book['version_data_date'] >
		,
		ReturnType< $shm_hitalama_footer['date'] >
	>
	type $mol_page__title_shm_dashboard_admin_book_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_dashboard_admin_book_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_page__foot_shm_dashboard_admin_book_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['foot'] >
	>
	type $mol_link__uri_shm_dashboard_admin_book_20 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_book['dashboard_url'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_shm_dashboard_admin_book_21 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_book['dashboard_url'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__target_shm_dashboard_admin_book_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['target'] >
	>
	type $mol_view__sub_shm_dashboard_admin_book_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_dashboard_admin_book_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_dashboard_admin_book_25 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_book['logout'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $shm_dashboard_admin_auth__state_shm_dashboard_admin_book_26 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_book['auth_state'] >
		,
		ReturnType< $shm_dashboard_admin_auth['state'] >
	>
	type $shm_dashboard_admin_auth__pb_url_override_shm_dashboard_admin_book_27 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_book['auth_pb_url_override'] >
		,
		ReturnType< $shm_dashboard_admin_auth['pb_url_override'] >
	>
	type $shm_dashboard_admin_server_charts__metric_history_shm_dashboard_admin_book_28 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_book['server_metric_history'] >
		,
		ReturnType< $shm_dashboard_admin_server_charts['metric_history'] >
	>
	export class $shm_dashboard_admin_book extends $mol_book2 {
		admin_pages( ): readonly(any)[]
		users_arg( ): Record<string, any>
		users_current( ): boolean
		Users_link( ): $shm_dashboard_admin_section_link
		wordstat_arg( ): Record<string, any>
		wordstat_current( ): boolean
		Wordstat_link( ): $shm_dashboard_admin_section_link
		monitoring_arg( ): Record<string, any>
		monitoring_current( ): boolean
		Monitoring_link( ): $shm_dashboard_admin_section_link
		server_arg( ): Record<string, any>
		server_current( ): boolean
		Server_link( ): $shm_dashboard_admin_section_link
		Navigation( ): $mol_view
		menu_session_rows( ): readonly(any)[]
		Menu_session( ): $mol_view
		version_data_version( ): string
		version_data_date( ): string
		Footer( ): $shm_hitalama_footer
		dashboard_url( ): string
		superuser_title( ): string
		logout( next?: any ): any
		auth_state( id: any, next?: string ): string
		auth_pb_url_override( next?: string ): string
		server_metric_history( ): readonly(any)[]
		section( next?: string ): string
		section_state_key( ): string
		placeholders( ): readonly(any)[]
		pages( ): ReturnType< $shm_dashboard_admin_book['admin_pages'] >
		Menu( ): $mol_page
		Dashboard_link( ): $mol_link
		Superuser( ): $mol_view
		Logout( ): $mol_button_minor
		Auth( ): $shm_dashboard_admin_auth
		Users( ): $shm_dashboard_admin_users
		Wordstat( ): $shm_dashboard_admin_wordstat
		Monitoring( ): $shm_dashboard_admin_monitoring
		Server( ): $shm_dashboard_admin_server
		Server_charts( ): $shm_dashboard_admin_server_charts
	}
	
	export class $shm_dashboard_admin_section_link extends $mol_link {
		uri_toggle( ): ReturnType< $shm_dashboard_admin_section_link['uri'] >
	}
	
}

//# sourceMappingURL=book.view.tree.d.ts.map